import { useQuery } from '@apollo/client';

import { CURRENT_EVENT } from '../graphql/query/currentEventQuery.graphql';

export const useCurrentEventQuery = () => {
  return useQuery(CURRENT_EVENT);
};
